import { useMemo } from "react";
import { Icon } from "../ui/Icon";
import { ORG_TYPE_META, type OrgUnitRow } from "./orgTypes";
import { layoutOrgHorizontal, ORG_M } from "./orgLayout";

/**
 * Organizasyon şeması — SOLDAN SAĞA SVG ağaç (kutular + dirsek bağlantılar).
 *
 * Yerleşim hesabı burada DEĞİL, `orgLayout.ts`te: baskı sayfası (/print/organizasyon-semasi)
 * aynı ağacı aynı sırayla çiziyor. İki yerde ayrı hesaplansaydı ekrandaki ile kâğıttaki
 * sıra zamanla ayrışırdı.
 *
 * Genişliğin neden derinliğe bağlandığı (eski yukarıdan-aşağı yerleşimin sorunu)
 * `orgLayout.ts` başlığında.
 *
 * Renk TEK BAŞINA anlatmaz: her kutuda tür ikonu + metin.
 */

interface Props {
  units: OrgUnitRow[];
  onSelect: (u: OrgUnitRow) => void;
}

export function OrgChart({ units, onSelect }: Props) {
  const layout = useMemo(() => layoutOrgHorizontal(units), [units]);
  const { NODE_W, NODE_H, PAD } = ORG_M;

  return (
    <div className="org-chart-scroll">
      <svg width={layout.width} height={layout.height} className="org-chart-svg" role="img" aria-label="Organizasyon şeması">
        {layout.links.map((l) => (
          <path key={l.id} d={l.d} className="org-link" fill="none" />
        ))}
        {layout.nodes.map((n) => {
          const meta = ORG_TYPE_META[n.u.type];
          return (
            <g key={n.u.id} className={`org-node ${!n.u.isActive ? "inactive" : ""}`} transform={`translate(${n.x + PAD}, ${n.y + PAD})`}
              onClick={() => onSelect(n.u)} role="button" tabIndex={0}
              aria-label={`${n.u.name} — ${meta.label}`}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onSelect(n.u); } }}>
              <rect width={NODE_W} height={NODE_H} rx={8} className="org-node-box" />
              <foreignObject x={0} y={0} width={NODE_W} height={NODE_H}>
                <div className="org-node-inner">
                  <span className="org-node-ic" aria-hidden="true"><Icon name={meta.icon} size={13} /></span>
                  <span className="org-node-txt">
                    <span className="org-node-name" title={n.u.name}>{n.u.name}</span>
                    {/* KÖKTE tesis adı yazılır: süper-admin "Tüm Tesisler"deyken birden çok
                        şirketin kökü alt alta gelir ve hangisinin hangisi olduğu ancak burada
                        anlaşılır. Alt birimler ebeveyninin tesisini aldığı için tekrarlanmaz. */}
                    <span className="org-node-type">
                      {n.u.parentId ? `${meta.label}${n.u.code ? ` · ${n.u.code}` : ""}` : (n.u.tesisName ?? "Global")}
                    </span>
                  </span>
                </div>
              </foreignObject>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
